import React from 'react';
import styled from 'styled-components';
import { red } from 'constants/colors';

interface PropTypes {
  children: JSX.Element;
}

const ErrorMessageWrapper: React.FC<PropTypes> = ({ children }) => (
  <StyledErrorLabelWrapper>
    <StyledErrorLabel>{children}</StyledErrorLabel>
  </StyledErrorLabelWrapper>
);

const StyledErrorLabelWrapper = styled.div`
  margin-bottom: 20px;
`;

const StyledErrorLabel = styled.div`
  color: ${red};
`;

export default ErrorMessageWrapper;
